import { useTheme } from "styled-components";

import logo from "@sso/assets/basemap-logo.png";
import { useMediaQuery } from "@sso/hooks/useMediaQuery";
import { ColumnContainer, Flex } from "@sso/ui/FlexBox";
import { Img } from "@sso/ui/Img";
import { Typography } from "@sso/ui/Typography";

interface AuthHeaderProps {
  title?: string;
  description?: string;
}
export const AuthHeader = ({ title, description }: AuthHeaderProps) => {
  const theme = useTheme();
  const matchesDownSM = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  return (
    <>
      <Flex
        direction={matchesDownSM ? "column-reverse" : "row"}
        borderBottom={`1px solid ${theme.colors.action.border}`}
        justify="space-between"
        padding={`0 0 ${matchesDownSM ? 1.5 : 1}rem 0`}
        margin="0 0 0.25rem 0"
      >
        <Typography fontWeight={600} size="1.5rem" color={theme.colors.primary.main}>
          Basemap SSO
        </Typography>
        <Img
          src={logo}
          alt="logo"
          width="auto"
          height="3rem"
          margin={matchesDownSM ? "0.25rem 0 1rem 0" : "0.25rem 0"}
        />
      </Flex>
      {(title || description) && (
        <ColumnContainer margin="1rem 0">
          {title && (
            <Typography fontWeight={600} size="1.3rem" color={theme.colors.secondary.dark}>
              {title}
            </Typography>
          )}
          {description && (
            <Typography
              fontWeight={500}
              size="1.1rem"
              margin={title ? "1rem 0 0 0" : "0"}
              color={theme.colors.text.secondary}
            >
              {description}
            </Typography>
          )}
        </ColumnContainer>
      )}
    </>
  );
};
